import React from 'react'
import { connect } from 'react-redux'
import { func, object, string } from 'prop-types'
import FaClose from 'react-icons/lib/fa/close'
import FaArrowLeft from 'react-icons/lib/fa/arrow-left'
import FaArrowRight from 'react-icons/lib/fa/arrow-right'
import ListActivities from '../StravaListActivities/StravaListActivities'
import StravaListData from '../StravaListData/StravaListData'
import styles from './Strava.styl'
import fetch from 'isomorphic-fetch'
// import { fetchStrava } from './Strava_redux'

class Strava extends React.Component {

	static fetchQueries = [
		'athletes/profile'
	]

	static propTypes = {
		session: object,
		strava: object,
		workout: object,
		workoutDate: string,
		fetchResults: object,
		dispatch: func,
		updateWorkout: func,
		fetchAction: func,
		close: func
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const { processing, activityId } = prevState
		const { strava } = nextProps
		if (processing && strava.activity[activityId]) {
			return { processing: false, transition: true }
		}
		return null
	}
	constructor(props) {
		super(props)
		const { fetchAction, workout } = props
		// fetchAction('/api/athletes/profile', ['FETCH_QUERIES_START', 'FETCH_QUERIES_SUCCESS', 'FETCH_QUERIES_REJECT'])
		this.state = {
			page: 1,
			activityId: null,
			transition: workout.athleteParams,
			processing: false
		}
	}

	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	handlePopup() {
		const options = {
			path: 'https://www.strava.com/oauth/authorize?client_id=22011&response_type=code&redirect_uri=https://beapt-endurance.com/api/strava&scope=read_all,activity:read_all&state=mystate&approval_prompt=force',
			// path: 'https://www.strava.com/oauth/authorize?client_id=22011&response_type=code&redirect_uri=http://localhost:3000/api/strava&scope=read_all&state=mystate&approval_prompt=force',
			windowName: 'stravaAuthWindow',
			windowOptions: 'location=0,status=0,width=1200,height=800'
		}
		window.stravaWindowCallback = this.handleAuth.bind(this)
		window.open(options.path, options.windowName, options.windowOptions)
	}
	handlePageFetch(page) {
		const { fetchAction } = this.props
		this.setState({ page })
		fetchAction(`/api/strava/activities/${ page }`, ['', 'PAGES_FETCH_SUCCESS', 'PAGE_FETCH_ERROR'], { fetchUrl: page })
	}
	handleActivityFetch(activityId) {
		const { fetchAction } = this.props
		fetchAction(`/api/strava/activity/${ activityId }`, ['', 'ACTIVITY_FETCH_SUCCESS', ''], { fetchUrl: activityId })
		this.setState({ activityId, processing: true })
		// this.setState({ activityId, transition: true })
	}
	handleAuth(sucess, strava) {
		const { dispatch } = this.props
		// const strava = fetch(`/api/strava?${ query }`).then(r => r.json())
		if (sucess) {
			dispatch({
				type: 'STRAVA_UPDATE',
				response: strava
			})
			this.handlePageFetch(1)
		} else {
			// TODO: ERRO!!!
		}
	}
	render() {
		const { page, activityId, transition, processing } = this.state
		const { close, session: { externals, email }, workout, strava, fetchResults, updateWorkout, workoutDate } = this.props
		const athlete = fetchResults[Strava.fetchQueries[0]]
		return (
			<main className={ styles.stravaPopup }>
				<section className={ styles['container'] }>
					<div className={ styles['title-container'] }>
						<div>
							{ transition ?
								<FaArrowLeft
									color="#fff"
									onClick={ () => { this.setState({ transition: false }) } }
								/> :
								<FaClose
									onClick={ close }
									color="#fff"
								/>
							}
							<h2>Registo de Treino - { workoutDate }</h2>
						</div>
						{ !transition ?
							<FaArrowRight
								onClick={ () => { this.setState({ transition: true }) } }
								color="#fff"
							/> :
							null
						}
					</div>
					<div className={ `${ styles['content'] } ${ transition ? styles['transition'] : '' }` }>
						<div className={ styles['activities-container'] }>
							{ !externals ?
								<div className={ styles.import }>
									<p>É necessário ligar ao STRAVA para obter os dados do teu treino.</p>
									<div className={ styles.stravaButton }>
										<img src="https://i.imgur.com/CTh1hVn.png" onClick={ this.handlePopup.bind(this) } />
									</div>
								</div> :
								<div>
									<div className={ styles.loggedIn }><h4>Conectado ao strava por <span>{ email }</span></h4></div>
									<ListActivities
										pages={ (strava.pages[page]) }
										handleActivityFetch={ this.handleActivityFetch.bind(this) }
										handlePageFetch={ this.handlePageFetch.bind(this) }
										processing={ processing }
									/>
								</div>
							}
						</div>
						{ athlete ?
							<div className={ styles['hidden'] }>
								<StravaListData
									workout={ workout }
									athlete={ athlete }
									updateWorkout={ (data) => { updateWorkout(data) } }
									data={ (strava.activity[activityId] || {}) }
									close={ close }
								/>
							</div> :
							null }
					</div>
				</section>
			</main>
		)
	}
}

const mapStateToProps = (state) => ({
	fetchResults: state.fetch.results,
	session: state.session,
	strava: state.strava
})

export default connect(mapStateToProps)(Strava)



// WEBPACK FOOTER //
// ./src/client/webapp/components/Strava/Strava.js